export function getConversationKeyFromUserIds(user1: string, user2: string) {
    let combinationId = user1.localeCompare(user2) <= 0 ? `${user1}-${user2}` : `${user2}-${user1}`;
    return `users/${combinationId}/messages`
}
